var render, staticRenderFns
import script from "./Pie.vue?vue&type=script&lang=js&"
export * from "./Pie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6af60c3c')) {
      api.createRecord('6af60c3c', component.options)
    } else {
      api.reload('6af60c3c', component.options)
    }
    
  }
}
component.options.__file = "src/components/Charts/Pie.vue"
export default component.exports